import * as ecAxios from '../util/ecAxios';

const usuariosMixin = {
	methods: {
		removeItem(item) {
			const index = this.selectedperson.indexOf(item.id);
			const indexList = this.personSelectedList.indexOf(item);
			if (index > -1 && indexList > -1) {
				this.selectedperson.splice(index, 1);
				this.personSelectedList.splice(index, 1);
			}
		},
		removeAllSelectedPerson() {
			this.selectedperson = [];
			this.personSelectedList = [];
		},
		selectPerson(personSelected) {
			if (this.personSelectedList.indexOf(personSelected) === -1) {
				this.selectedperson.push(personSelected.id);
				this.personSelectedList.push(personSelected);
				this.resultSearch = [];
				this.searchInput = '';
			}
		},
		filterSearch(field) {
			if (typeof field === 'number') {
				// eslint-disable-next-line no-param-reassign
				field = field.toString();
			}
			if (field === null) {
				// eslint-disable-next-line no-param-reassign
				field = '';
			}
			return field.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1;
		},
		async editperson() {
			if (this.$route.params.id) {
				await ecAxios
					.connection()
					.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_PESSOAS_USUARIO_SALVAR}`, {
						usuario_id: this.userData.id,
						pessoas: this.selectedperson,
					})
					.then((response) => {
						if (response.status === 200) {
							this.getPessoas();
						}
					})
					.catch((e) => {
						this.$buefy.notification.open({
							message: e.toString(),
							type: 'is-danger',
						});
					});
			}
		},
		async edituser() {
			if (this.$route.params.id) {
				await ecAxios
					.connection()
					.put(
						`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_USUARIO}${this.$route.params.id}`,
						this.userData
					)
					.then((response) => {
						if (response.status === 200) {
							this.goBack();
						}
					})
					.catch((e) => {
						this.$buefy.notification.open({
							message: e.toString(),
							type: 'is-danger',
						});
					});
			}
		},
    parseData(data) {
      return data.filter((dataRec) => !this.data.some((item) => item.id === dataRec.id));
  },
		async searchpessoas(searchPessoasInput) {
			if (searchPessoasInput !== '') {
				await ecAxios
					.connection()
					.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_PESSOAS_USUARIO}`, {
						offset: 0,
						limit: 5,
						usuario_id_out: parseInt(this.userData.id, 10),
						search: searchPessoasInput.toUpperCase(),
					})
					.then((response) => {
						if (response.data.pessoas) {
							this.resultSearch = this.parseData(response.data.pessoas);
						}
					})
					.catch((e) => {
						this.$buefy.notification.open({
							message: e.toString(),
							type: 'is-danger',
						});
					});
			} else {
				this.resultSearch = [];
			}
		},
		async getPessoas() {
			if (this.$route.params.id) {
				await ecAxios
					.connection()
					.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_PESSOAS_USUARIO}`, {
						offset: 0,
						limit: 100000,
						search: '',
						// eslint-disable-next-line radix
						usuario_id: parseInt(this.$route.params.id),
					})
					.then((response) => {
						if (response) {
							this.data = response.data.pessoas;
						}
					})
					.catch((e) => {
						this.$buefy.notification.open({
							message: e.toString(),
							type: 'is-danger',
						});
					});
			}
		},
		goBack() {
			if (window.history.length > 1) {
				this.$router.go(-1);
			} else {
				this.$router.push('/');
			}
		},
		async getUser() {
			if (this.$route.params.id) {
				await ecAxios
					.connection()
					.get(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_USUARIO}${this.$route.params.id}`)
					.then((response) => {
						if (response) {
							this.userData = response.data.usuario;
						}
					})
					.catch((e) => {
						this.$buefy.notification.open({
							message: e.toString(),
							type: 'is-danger',
						});
					});
			}
		},
	},
};

export default usuariosMixin;

